<template>
	<b-container class="m-0 p-0">
		<b-button v-if="status === 'loading'" class="loading">
			<b-spinner label="loading" small></b-spinner>
		</b-button>

		<b-button v-else-if="status === 'error'" class="error">
			<b-icon icon="exclamation-circle" variant="danger" ></b-icon>
		</b-button>
		<b-button
			v-else-if="status === 'fetched'"
			class="class text-left px-2"
			:variant="Class.isSignedUp ? 'primary' : isFull ? 'danger' : 'light'"
			v-b-modal="modalID"
			>{{ displayText }}</b-button
		>

		<b-modal
			:id="modalID"
			:title="modalTitle"
			cancel-title="Back"
			:ok-title="Class.isSignedUp ? 'Cancel' : 'Sign Up'"
			:ok-disabled="isFull && !Class.isSignedUp"
			:ok-variant="Class.isSignedUp ? 'danger' : 'primary'"
			size="lg"
			centered
			@ok="Class.isSignedUp ? cancelClass() : signUpForClass()"
		>
			<b-container fluid>
				<b-row v-if="Class.isSignedUp">
					<b-col v-if="Class.url">
						<b-link
							
							:href="'https://'+Class.url"
							target="_blank"
							class="d-block text-center mb-1"
						>
							Click here to join the video call for this class
						</b-link>
						<span class='d-block'>
							<span class="text-warning font-weight-bold">Note:</span> Invites to the Google Meet call will be sent ~24hrs before class start
							<br/>
							If you signed up after the invites have been sent, simply click on "Ask to join" and the therapist will accept you into the call once they log on.
						</span>
					</b-col>
					<b-col v-else>
						<h6 class="text-warning text-center">
							Link to video call not yet available. Check again closer to
							the class start time.
						</h6>
					</b-col>
				</b-row>

				<b-row class="text-center">
					<b-col col>
						<div class="font-weight-bold">Status</div>
						<div>
							{{
								Class.isSignedUp
									? "Signed Up"
									: isFull
									? "Full"
									: "Available"
							}}
						</div>
					</b-col>

					<b-col col>
						<div class="font-weight-bold">Instructor</div>
						<div>
							{{
								Class.instructor.firstName +
									" " +
									Class.instructor.lastName +
									" " +
									Class.instructor.creds
							}}
						</div>
					</b-col>

					<b-col col>
						<div class="font-weight-bold">Max attendees</div>
						<div>{{ Class.max }}</div>
					</b-col>
				</b-row>

				<hr />

				<b-row>
					<b-col>
						<h5>{{ Class.template.title }}</h5>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<span style="white-space: pre-line">{{ Class.template.description }}</span>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</b-container>
</template>

<script>
// 6 -> 06
function padWithZero(day) {
	if (day.length === 1) {
		return "0" + day
	} else {
		return day
	}
}

export default {
	name: "Class",
	data() {
		return {
			status: "loading",
			modalVisible: false,
			Class: {
				date: "",
				time: "",
				rosterCount: 0,
				max: 0,
				isSignedUp: false,
				template: {
					id: 0,
					title: "",
					description: "",
				},
				instructor: {
					id: 0,
					firstName: "",
					lastName: "",
					creds: "",
				},
				url: "",
			},
		}
	},
	props: {
		classID: {
			type: Number,
			required: true,
		},
		lateCx: {
			type: Boolean,
			required: true,
		},
		year: {
			type: Number,
			required: false,
		},
		month: {
			type: Number,
			required: false,
		},
		day: {
			type: Number,
			required: true,
		},
	},
	computed: {
		timeString() {
			try {
				if (parseInt(this.Class.time.substr(0, 2)) === 12) {
					return this.Class.time.substr(0, 5) + "PM"
				}
				else if (parseInt(this.Class.time.substr(0, 2)) > 12) {
					// Get hour substring from full time string
					// convert to integer and deduct 12
					// pad with zero if necessary
					// append PM
					return (
						padWithZero(
							(parseInt(this.Class.time.substr(0, 2)) - 12).toString()
						) +
						this.Class.time.substr(2, 3) +
						"PM"
					)
				} else {
					return this.Class.time.substr(0, 5) + "AM"
				}
			} catch {
				return ""
			}
		},
		displayText() {
			try {
				return this.timeString + " - " + this.Class.template.title
			} catch {
				return ""
			}
		},
		modalTitle() {
			try {
				return (
					new Date(this.year, this.month, this.day, 0,0,0,0).toDateString() +
					" @ " +
					this.displayText
				)
			} catch {
				return ""
			}
		},
		isFull() {
			if (this.Class.rosterCount === this.Class.max) {
				return true
			} else {
				return false
			}
		},
		isAdmin() {
			return this.$store.getters.isAdmin
		},
		modalID() {
			return "classDetails-" + this.classID.toString()
		},
	},
	methods: {
		getClassDetails: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/onlineClassDetails", {
					method: "POST",
					body: JSON.stringify({
						classID: this.classID,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(Class => {
							this.Class = Class
							resolve()
						})
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						reject(res)
					}
				})
			})
		},
		cancelClass: function() {
			if (this.lateCx) {
				alert('Class reservations must be cancelled by 4PM on the previous day.')
			}
			else {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/removeUserFromOnlineClass", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							classID: this.classID,
						}),
					}).then(res => {
						if (res.ok) {
							this.status = "loading"
							this.updateClass()
								.then(() => {
									this.status = "fetched"
								})
								.then(() => {
									alert("Class registration cancelled")
								})
							resolve()
						} else if (res.status === 401) {
							this.$store.dispatch("logout").then(() => {
								this.$router.push("/Login")
								reject(res)
							})
						} else {
							this.status = "loading"
							this.updateClass()
								.then(() => {
									this.status = "fetched"
								})
								.then(() => {
									alert("An error has occured, please try again.")
								})
							resolve()
						}
					})
				})
			}
		},
		signUpForClass: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/addUserToOnlineClass", {
					method: "POST",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						classID: this.classID,
					}),
				}).then(res => {
					if (res.ok) {
						this.status = "loading"
						this.updateClass()
							.then(() => {
								this.status = "fetched"
							})
							.then(() => {
								alert("Signed up for class")
							})
						resolve()
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						this.status = "loading"
						this.updateClass()
							.then(() => {
								this.status = "fetched"
							})
							.then(() => {
								alert("An error has occured, please try again.")
							})
						resolve()
					}
				})
			})
		},
		updateClass: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/onlineClassDetails", {
					method: "POST",
					body: JSON.stringify({
						classID: this.classID,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(Class => {
							// Only overwrite current class data if new data is different
							if (this.Class === Class) {
								resolve()
							} else {
								this.Class = Class
								resolve()
							}
						})
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						reject(res)
					}
				})
			})
		},
	},
	created() {
		this.getClassDetails().then(() => {
			this.status = "fetched"
		})
	},
}
</script>

<style scoped>
.error,
.loading,
.class {
	display: block;
	margin: 8px auto;
	width: 100%;
}
</style>
